document.addEventListener('DOMContentLoaded', () => {
  const $applicationsErrors  = document.querySelectorAll('.job-manager-applications-error')
  const $jobListingMeta = document.querySelector('.job-listing-meta')
  const $phone = document.querySelector('#phone')
  const $resume = document.querySelector('#resume')

  if ($jobListingMeta) {
    $applicationsErrors.forEach(($el) => {
      $jobListingMeta.insertAdjacentElement('afterend', $el);
    })
  }

  if ($phone) {
    $phone.setAttribute('x-mask', '(999) 999-9999')
  }

  if ($resume) {
    $resume.setAttribute('required', 'true')
  }
})
